//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getPlanPrice: 'product/getPlanPrice'
    }),
    biomarkers () {
      return this.starterTest.test.biomarkersTested
    },
    testType () {
      return this.starterTest.test.collectionType
    },
    image () {
      return this.getStaticsObject('/quiz-results/starter_test_prick.webp')
    },
    carouselImages () {
      return [
        'https://statics.get-base.com/boxes/elimiation-diet-flat-box-low.jpg',
        'https://statics.get-base.com/quiz-results/starter_test_inside_box_prick.webp',
        'https://statics.get-base.com/quiz-results/starter_test_collection_prick.webp'
      ]
    }
  },
  methods: {
    navigateToStripePayment () {
      window.location.href = 'https://buy.stripe.com/bIY6qg041fQLbfOdR6'
    },
    scrollTo () {
      location.hash = ''
      location.hash = '#faq-list'
    }
  }
}
